import { DiscountBlock, TContainer } from "./Title.styled";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { PricingActualPlans } from "../../../interfaces";

interface TitleProps {}

export const Title = observer(({}: TitleProps) => {
	const { pricingActualStore } = useStores();

	const { t } = useTranslation();

	return (
		<TContainer>
			{t("pages.pricing.title", {
				percent: [PricingActualPlans.PACKS, PricingActualPlans.SKILL_BUNDLES].includes(pricingActualStore.plans)
					? 75
					: 50,
			})}
			<DiscountBlock>{t("pages.pricing.description")}</DiscountBlock>
		</TContainer>
	);
});
